import { Fragment } from 'react'
import PropTypes from 'prop-types'
import AdminDonutChart from 'components/AdminDonutChart'
import { transformGradeBandForDonutChart } from 'components/AdminK8Tier2MultiSiteView/helpers'
import {
  ChartsWrapper,
  LessonCompletionLink,
  SiteViewWrapper,
  StyledAdminHairline,
} from './component.styles'
import { DEFAULT_GRADE_BANDS, LESSON_COMPLETION_LINK_TEXT } from './constants'
import { createSeeLessonCompletionHandler } from './helpers'

const SiteView = ({ isSingleSite, navigationEvent, site }) => {
  const navigationHandler = createSeeLessonCompletionHandler(navigationEvent)
  return (
    <SiteViewWrapper isSingleSite={isSingleSite}>
      <ChartsWrapper>
        {(site.gradeBandData || DEFAULT_GRADE_BANDS).map(
          (gradeBand, gradeIndex) => {
            const transformedData = transformGradeBandForDonutChart(gradeBand)
            const isLastGradeBand = gradeIndex === site.gradeBandData.length - 1

            return (
              <Fragment key={gradeBand.gradeBand || gradeIndex}>
                <AdminDonutChart
                  data={transformedData}
                  key={gradeBand.gradeBand || gradeIndex}
                  programName="K-8 Tier 2 Grade Band"
                  siteId={site.siteId}
                />
                {!isLastGradeBand && <StyledAdminHairline />}
              </Fragment>
            )
          },
        )}
      </ChartsWrapper>
      <LessonCompletionLink onClick={() => navigationHandler(site.siteId)}>
        {LESSON_COMPLETION_LINK_TEXT}
      </LessonCompletionLink>
    </SiteViewWrapper>
  )
}

SiteView.propTypes = {
  isSingleSite: PropTypes.bool,
  navigationEvent: PropTypes.func.isRequired,
  site: PropTypes.shape({
    gradeBandData: PropTypes.array,
    siteId: PropTypes.number.isRequired,
  }).isRequired,
}

export default SiteView
